document.addEventListener('toggle', (event) => {
  const menu = event.target;
  if (!menu.matches?.('.wb-department') || !menu.open) return;
  menu.parentElement.querySelectorAll(':scope > .wb-department[open]').forEach((sibling) => {
    if (sibling !== menu) sibling.open = false;
  });
}, true);
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = event.target.closest('.wb-department[open]') || event.target.closest('.wb-mobile-shop[open]') || document.querySelector('.wb-nav-desktop .wb-department[open]');
  if (!menu) return;
  menu.open = false;
  menu.querySelector('summary')?.focus();
  event.preventDefault();
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.wb-department[open], .wb-mobile-shop[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
